module.exports = __webpack_public_path__ + "img/bg-hero.b0594088.svg";